<template>
  <vx-card class="Payslip-Reports">
    <div class="vx-col md:w-1/2 w-full mt-5">
      <span class="text-sm">Users</span><span style="color: red">*</span>
      <v-select
        v-validate="'required'"
        class="w-full"
        name="Users"
        v-model="selectedUser"
        label="fullName"
        :options="getusers"
        placeholder="Please Select"
        @input="handleUserSelection"
      />
      <span class="text-danger">{{ errors.first("Users") }}</span>
    </div>

    <div>
      <div
        class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
      >
        <div class="vx-col sm:w-1/5 md:w-1/5 lg:w-1/5 xl:w-1/5 w-full mb-2">
          <span class="text-sm">Payout Date </span
          ><span style="color: red">*</span>
          <v-select
            class="mb-3"
            v-model="payOutDate"
            name="payOutDate-name"
            :options="payOutDateList"
          />
          <vs-button
            class="download-Payslip"
            type="gradient"
            color="primary"
            @click="downloadPayslip()"
            icon-pack="feather"
            icon="icon-download"
            :disabled="this.payOutDate == null"
            >Download</vs-button
          >
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import axios from "@/axios.js";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      selectedUser: null,
      id: null,
      fullName: "",
      loadedRatio: 0,
      payOutDateList: [],
      payOutDate: null,
      linkURL: "",
      p: "Dela Cruz2007-004",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getusers() {
      return this.$store.state.hrms.allEmployee;
    },
    convertPayOutDate() {
      return (d) => {
        var dt = moment(d, "YYYYMMDD");
        return dt.format("DD-MMM-YYYY");
      };
    },
  },
  watch: {
    selectedUser() {
      // Call the method to format the user ID

      this.UserId();
    },

    payOutDate() {
      this.linkURL = null;
      this.loadingTask();
    },
  },
  methods: {
    UserId() {
      // Check if selectedUser and userId exist
      if (this.selectedUser && this.selectedUser.id) {
        // Assign the raw user ID to the formattedUserId
        this.uid = this.selectedUser.id;

        // Reset payOutDate when a user is selected
        this.payOutDate = null;
      } else {
        this.uid = null; // Handle the case where there is no selected user or user ID
      }
    },
    handleUserSelection() {
      if (this.selectedUser && this.selectedUser.id) {
        this.uid = this.selectedUser.id;
        this.getPaylipList(); // Call getPaylipList when user is selected
      } else {
        this.uid = null;
      }
    },
    getPaylipList() {
      this.payOutDateList = [];
      this.$vs.loading();

      try {
        if (!this.selectedUser) {
          throw new Error("selectedUser is null or undefined.");
        }

        if (
          this.selectedUser.id === undefined ||
          this.selectedUser.id === null
        ) {
          throw new Error("selectedUser does not have an id property.");
        }

        const userId = String(this.selectedUser.id);

        this.$store
          .dispatch("getPayslipList", userId)
          .then((response) => {
            let p = response.data;
            p.forEach((payOutDate) => {
              this.payOutDateList.push(
                this.convertPayOutDate(payOutDate.substr(payOutDate.length - 8))
              );
            });
            this.$vs.loading.close();
          })
          .catch((error) => {
            console.error("Error fetching pay slip list:", error);
            this.$vs.loading.close();
          });
      } catch (error) {
        console.error("Error in getPaylipList:", error.message);
        this.$vs.loading.close();
      }
    },

    loadingTask() {
      this.linkURL = null;
      if (this.payOutDate != null) {
        const data = {
          userId: this.selectedUser ? this.selectedUser.id : null,
          payOutDate: moment(this.payOutDate).format("YYYYMMDD"),
        };
        this.$store
          .dispatch("getViewPayslip", data)
          .then((response) => {
            this.linkURL = response.request.responseURL;
            console.log(this.linkURL);
          })
          .catch((error) => {
            this.linkURL = null;
            this.$alert(error, "Error", "error");
          });
      }
    },

    error: function (err) {
      this.$alert(err, "Error", "error");
    },

    downloadPayslip() {
      this.$vs.loading();

      axios
        .get(this.linkURL, {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
        })
        .then((response) => {
          this.$vs.loading.close();

          // Check if the response has content-disposition header
          const contentDisposition = response.headers["content-disposition"];
          if (!contentDisposition) {
            // Handle the case where the header is not present
            console.error("Content-Disposition header not found");
            return;
          }

          // Extract the filename from the content-disposition header
          const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);
          if (!fileNameMatch) {
            // Use a default filename if the filename is not found in the header
            console.warn(
              "Filename not found in Content-Disposition header. Using default filename."
            );
          }

          // Extract user ID and payout date
          const userId = this.selectedUser
            ? this.selectedUser.id
            : "unknownUserId";
          const payoutDate = this.payOutDate
            ? moment(this.payOutDate).format("YYYYMMDD")
            : "unknownPayoutDate";

          // Construct the filename
          const fileName = fileNameMatch
            ? fileNameMatch[1]
            : `${userId}_${payoutDate}.pdf`;

          // Create a Blob from the response data
          const blob = new Blob([response.data]);

          // Create a download link
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;

          // Trigger the download
          link.click();

          // Clean up
          window.URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.error("Error downloading payslip:", error);
        });
    },
  },
};
</script>

<style>
.Payslip-Reports {
  text-align: center;
}

.Payslip-Reports .vx-col {
  max-width: 400px; /* Adjust the max-width as needed */
  width: 100%;
  margin: 0 auto; /* Center the column horizontally */
}

.Payslip-Reports .vx-row {
  width: 100%;
}
.download-Payslip {
  display: flex;
  margin: 0 auto;
}
</style>
